export const CHANGED_TOOLBAR = 'changed-toolbar';
export const SEARCH = 'cx-search';

const $ = jQuery;
const AUTO_SEARCH_DELAY = 1000; //ms
const AUTO_SEARCH_MIN_CHARS = 3;

let input = null;
let searchButton = null;
let searchInput = null;
let postsPerPageSelect = null;
let autoSearchTimeout = null;

export function getToolbarState() {
	let postsPerPage = parseInt(postsPerPageSelect.val(), 10);
	let activeSortButton = el.find('.sort-button.active');
	let sortBy = activeSortButton.attr('data-sort-by');
	let sortDir = activeSortButton.attr('class').match(/(asc|desc)/)[0];
	let search = searchInput.val();

	return { postsPerPage, sortBy, sortDir, search };
}

export function setToolbarState({ postsPerPage, sortBy, sortDir, search }) {
	postsPerPageSelect.val(postsPerPage);
	searchInput.val(search);
	el.find('.sort-button').removeClass('active asc desc');
	el
		.find(`.sort-button[data-sort-by="${sortBy}"]`)
		.addClass(`active ${sortDir}`);
}

let el = null;

function onDocumentReady() {
	el = $('#university-toolbar').length > 0 ? $('#university-toolbar') : $('#content-exchange-toolbar');
	if (el.length > 0) {
		initialize();
		el = $('#university-grid').length > 0 ? $('#university-grid') : $('#content-exchange-sidebar');

		input = document.querySelector('.content-exchange-search-input');
		searchButton = document.querySelector('.content-exchange-search-button');
		if (searchButton && input) {
			searchButton.addEventListener('click', handleIt);
		}
	}
}

function handleIt(e) {
	if (input.classList.contains('active')) {
		input.classList.remove('active');
	} else {
		e.preventDefault();
		input.classList.add('active');
	}
}
function onClickSearchIcon(e) {
	if (searchInput.val()) {
		searchInput.closest('.content-exchange-search').trigger('submit');
	}
}

function onSearchSubmit(e) {
	e.preventDefault();
	el.trigger(SEARCH);

	return false;
}

function onClickSortButton(e) {
	let clicked = $(e.currentTarget);

	if (clicked.hasClass('active')) {
		clicked.toggleClass('asc desc');
	} else {
		el.find('.sort-button.active').removeClass('active asc desc');
		clicked.addClass('active asc');
	}

	el.trigger(CHANGED_TOOLBAR);
}

function onSelectPostsPerPage(e) {
	el.trigger(CHANGED_TOOLBAR);
}

function onChangeSearchInput(e) {
	clearTimeout(autoSearchTimeout);

	if (searchInput.val()) {
		autoSearchTimeout = setTimeout(performAutoSearch, AUTO_SEARCH_DELAY);
	} else {
		el.trigger(SEARCH);
	}
}

function performAutoSearch() {
	let val = searchInput.val();
	if (val.length >= AUTO_SEARCH_MIN_CHARS) {
		el.trigger(SEARCH);
	}

	clearTimeout(autoSearchTimeout);
}

function initialize() {
	searchInput = el.find('[name="cxq"]');
	postsPerPageSelect = el.find('[name="posts-per-page"]');
	console.log(postsPerPageSelect);
	el.on('click', '.sort-button', onClickSortButton);
	el.on('change', '[name="posts-per-page"]', onSelectPostsPerPage);
	el.on('submit', '.content-exchange-search', onSearchSubmit);
	el.on('click', '.icon-search', onClickSearchIcon);
	el.on('keyup', '[name="cxq"]', onChangeSearchInput);
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
